import { useEffect, useState } from 'react';
import { getExpiresAtMs } from '@/api/bozp-token';
import { useT } from '@/i18n';

function fmt(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Shows a countdown when the scoped session is within 5 minutes of expiry. */
export function SessionExpiryBanner() {
  const t = useT();
  const [remaining, setRemaining] = useState<number | null>(null);

  useEffect(() => {
    const tick = () => {
      const exp = getExpiresAtMs();
      setRemaining(exp == null ? null : exp - Date.now());
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (remaining == null || remaining <= 0 || remaining > 5 * 60 * 1000) return null;
  return (
    <div
      role="status"
      className="sticky top-0 z-40 flex items-center justify-center gap-2 border-b border-fixit-200 bg-fixit-50 px-4 py-2 text-center text-sm font-semibold text-fixit-800"
    >
      <span
        aria-hidden
        className="hb-spinner !h-3.5 !w-3.5 !border-fixit-300 !border-t-fixit-600"
      />
      {t('Session expires in {time}', { time: fmt(remaining) })}
    </div>
  );
}
